import {createAction, props} from '@ngrx/store';
import {UUID} from '../../../shared/types/uuid.type';
import {Destination} from '../../../services/api/destinations/destination.model';

export const deleteDestination = createAction(
  '[DeleteDestination] Delete Destination',
  props<{ id: UUID }>()
);

export const deleteDestinationSuccess = createAction(
  '[DeleteDestination] Delete Destination Success',
  props<{ data: Destination }>()
);

export const deleteDestinationFailure = createAction(
  '[DeleteDestination] Delete Destination Failure',
  props<{ error: any }>()
);

export const clearDeleteDestinationState = createAction(
  '[DeleteDestination] clear Delete Destination State'
);
